var keyMirror = require('./../../lib/keyMirror');

module.exports = keyMirror({
    'text': null,
    'modify_msg': null,
    'tip': null,
    'operation_tip': null,
    'auth_tip': null,
    'image': null,
    'file': null,
    'video': null,
    'audio': null,
    'call_audio': null,
    'call_video': null,
    'standard_evaluate_card1': null,
    'standard_evaluate_card2': null,
    'universal_card1': null,
    'universal_card2': null,
    'universal_card3': null,
    'universal_card4': null,
    'universal_card5': null,
    'universal_card6': null,
    'wuba_card': null,
    'private_card_ganji': null,
    'shop_common_card': null,
    'provide_contactinfo_card':null,
    'default_contactinfo_card':null,
    'provide_contactinfo_card':null,
    'msg_batch_forward_card': null,
    'chat_card':null
});